'use strict';
const _ = require('lodash');
const Backbone = require('backbone');
const PubSub = require('../PubSub');
const template = require('../templates/social_contestant.ejs');
const slugify = require('slugify');

module.exports = Backbone.View.extend({
  className: 'contestant flex-child-container',
  events: {
    'click .img-position': 'loadVideo',
    'click button.btn-submit': 'submitLiveVote'
  },
  submittingVote: false,
  /**
   *
   */
  initialize: function (options) {
    _.bindAll(this, 'render', 'onCloseModal', 'onVoteSuccess', 'onSubmittingVote');

    options = options || {};
    this.user = options.user;
    this.temp = options.temp;
    this.person = options.person;
    this.dimensions = options.dimensions;
    this.copy = options.copy;
    this.professional = options.professional;
    this.category = options.category;
    this.active = options.active;

    this.voteLimit = parseInt(options.cms.turboVote.get('voteLimit'), 10);

    this.imageQsp = '?';
  },
  /**
   *
   */
  render: function () {

    var modelData = _.extend({}, this.model.toJSON(), {
      voteData: {},
      copy: this.copy,
      professional: this.professional,
      twitter: parseInt(this.category.get('live_vote')),
      active: this.active,
      isSubmitted: this.category.get('isSubmitted')
    });

    var updatedModel = this.buildImageURLs(modelData);

    if (this.temp) {
      this.$el.addClass('temp');
    }

    if (!updatedModel.percent) {
      updatedModel.percent = "0";
    }

    this.$el.html(template(updatedModel));
    this.$el.find('img').unveil(2 * window.innerHeight);
    return this;
  },
  /**
   * [buildImageURLs description]
   * @param  {[type]} data [description]
   * @return {[type]}      [description]
   */
  buildImageURLs: function (data) {
    var node = (parseInt(this.person)) ? 'circle' : 'rectangle';

    _.forEach(this.dimensions[node], function (value, index) {
      if (value != '') {
        this.imageQsp = this.imageQsp + index + '=' + value + "&";

        if (/(width)/.test(index)) {
          this.width = value;
        } else if (/(height)/.test(index)) {
          this.height = value;
        }
      }
    }.bind(this));

    this.imageQsp = this.imageQsp.slice(0, -1);

    data.formatted_image = data.image_url + this.imageQsp;
    data.width = this.width;
    data.height = this.height;

    return data
  },
  /**
   * [renderedToDom description]
   * @return {[type]} [description]
   */
  renderedToDom: function () {
    this.listenTo(PubSub, 'voteSuccess', this.onVoteSuccess);
    this.listenTo(PubSub, 'directRoute', this.onCloseModal);
    this.listenTo(PubSub, 'submittingVote', this.onSubmittingVote);
  },
  /**
  *
  */
  onSubmittingVote: function (voteData) {
    const btn = this.$el.find('.btn-submit');

    if (voteData.contestant === this.model.get('id')) {
      this.submittingVote = true;
      btn.addClass('btn-loading');
    }
  },
  /**
  *
  */
  onCloseModal: function (value) {
    const btn = this.$el.find('.btn-submit');

    if (!this.submittingVote && (value === 'closeCurrentModal' || value === 'error')) {
      btn.removeClass('btn-loading');
      this.submittingVote = false;
    }
  },
  /**
   *
   */
  onVoteSuccess: function (response, voteData) {
    const btn = this.$el.find('.btn-submit');

    if (voteData.contestant === this.model.get('id')) {
      btn.removeClass('btn-loading');
      btn.addClass('btn-complete');
      this.submittingVote = false;

      setTimeout( function() {
          btn.removeClass('btn-complete');
      }.bind(this), 2000);
    }

  },
  /**
   *
   */
  loadVideo: function (e) {
    if (this.temp || this.model.get('video_url') === '') return;

    var lowerCategoryName = this.category.get('name').toLowerCase();
    var lowerContestantName = this.model.get('name').toLowerCase();

    var omParams = {
      name: 'video_' + lowerCategoryName + '_' + lowerContestantName,
      section: slugify(this.category.get('name')), 
      url: window.location.href
    };
    var gaParams = {
      eventCategory: 'Button Click',
      eventAction: 'Watch Video : ' + this.category.get('name') + ' : ' + this.model.id
    };

    PubSub.trigger('loadVideo', this.model.toJSON(), this.category);
    PubSub.trigger('linkClick', omParams, gaParams);
  },
  /**
   * [remove description]
   * @return {[type]} [description]
   */
  remove: function () {
    this.off();
    this.stopListening();

    this.model = null;

    if (typeof this.transitionTimeout == 'number') clearTimeout(this.transitionTimeout);

    this.imageQsp = null;
    this.person = null;
    this.dimensions = null;

    return Backbone.View.prototype.remove.call(this);
  },

  /**
   * Submit votes for the category
   */
  submitLiveVote: _.throttle(function (e) {
    e.preventDefault();

    const votes = this.model.get('voteCount');
    const categoryVotesTotal = this.category.get('categoryVotesTotal');
    const categoryVotes = this.category.get('categoryVotes');

    if (categoryVotesTotal < this.voteLimit && votes < this.voteLimit) {
      this.model.set('voteCount', votes + 1);
      this.category.voteCountUpdate('plus', this.model.get('id'), this.model.get('voteCount'));

      var data = _.extend({
        categoryID: this.category.get('id'),
        categoryName: this.category.get('name'),
        categoryVoteData: {
          contestant: this.model.get('id')
        },
        categoryVotesTotal: categoryVotesTotal + 1
      }, categoryVotes);

      PubSub.trigger('submitVotes', data);
    }
  }, 500)

});



// WEBPACK FOOTER //
// ./app/scripts/views/social_contestant.js